/* eslint-disable jsx-a11y/anchor-is-valid */
//import axios from 'axios'
import React from 'react'
import {useIntl} from 'react-intl'

//const API_URL = process.env.REACT_APP_API_URL || 'api'

type Props = {
  className: string
  cost_total?: string
  installments_paid?: string
  status?: string
}

const CardSystemWidgetOneContract2: React.FC<Props> = ({
  className,
  cost_total,
  installments_paid,
  status,
}) => {
  // const [total, setTotal] = useState('')
  const intl = useIntl()
  return (
    <div
      className={`card ${className} 
          border          
          border-gray-300                   
          `}
    >
      {/* begin::Body */}
      <div className='d-flex align-items-start mx-5 px-5 mt-5'>
        <div className='d-flex flex-column flex-grow-1 '>
          {/* {cost_total ? ( */}
          <>
            {/* begin::Row */}
            <div className='row'>
              {/* begin::Col */}
              <div className='col-xl-12'>
                <h5 className='mt-0 mb-4 fs-3'>
                  {intl.formatMessage({id: 'CONTRACTS.ADDITIONAL_INFORMATION'})}
                </h5>
              </div>

              <div className='col-xl-4 mt-2 mb-4 fs-7 fw-bold  '>
                <div className='rounded border border-dashed border-gray-300 text-center'>
                  <div className='mt-2 text-dark  '>
                    {intl.formatMessage({id: 'CONTRACTS.COST_TOTAL'})}
                  </div>
                  <div className='mb-3 fs-3 text-warning'>R$ {cost_total || ' '}</div>
                </div>
              </div>

              <div className='col-xl-4 mt-2 mb-4 fw-bold '>
                <div className='w-90 rounded border border-dashed border-gray-300 text-center'>
                  <div className='mt-2 text-dark'>
                    {intl.formatMessage({id: 'CONTRACTS.INSTALLMENTS_PAID'})}
                  </div>
                  <div className=' mb-3 fs-3 text-info'>{installments_paid || 12}</div>
                </div>
              </div>

              <div className='col-xl-4 mt-2 mb-4 fs-7 fw-bold '>
                <div className='w-90 rounded border border-dashed border-gray-300 text-center'>
                  <div className='mt-2 text-dark'>{intl.formatMessage({id: 'COMMON.STATUS'})}</div>
                  <div className='badge badge-success mb-3 fs-7'>{status || 'Ativo'}</div>
                </div>
              </div>

              <div className='col-xl-4 mt-2 mb-4 fs-7 fw-bold '> </div>
            </div>
          </>
          {/* ) : (
            <CardLoading />
          )} */}
        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}

export {CardSystemWidgetOneContract2}
